import queryString from 'query-string';
import parse from 'html-react-parser';
import { BASE_FILE_URL } from './constants';
import * as cheerio from 'cheerio'; // ✅ Sửa lỗi undefined 'load'
import { format, parseISO } from 'date-fns';
import { vi } from 'date-fns/locale';
import { fetchPageConfig, pageConfig } from './pageConfig';

export function stringifyQuery(query = {}, options = {}) {
  return queryString.stringify(query, { skipEmptyString: true, skipNull: true, arrayFormat: 'bracket', ...options });
}

export const stripHtmlTagsAdvanced = (htmlString) => {
  return htmlString
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // Loại bỏ script tags
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '') // Loại bỏ style tags
    .replace(/<[^>]*>/g, '') // Loại bỏ tất cả HTML tags
    .replace(/&nbsp;/g, ' ') // Thay thế &nbsp; bằng space
    .replace(/&amp;/g, '&') // Thay thế &amp; bằng &
    .replace(/&lt;/g, '<') // Thay thế &lt; bằng <
    .replace(/&gt;/g, '>') // Thay thế &gt; bằng >
    .replace(/&quot;/g, '"') // Thay thế &quot; bằng "
    .replace(/&#39;/g, "'") // Thay thế &#39; bằng '
    .replace(/\s+/g, ' ') // Loại bỏ multiple spaces
    .trim();
};
/**
 * @param {string} html - Nội dung HTML gốc
 * @param {Array} imageData - Mảng dữ liệu ảnh (large, medium, small...)
 * @returns {string} HTML sau khi thay ảnh
 */
export function replaceImages(html, imageData, deviceType) {
  const $ = cheerio.load(html);

  $('img').each((_, img) => {
    const $img = $(img);
    const src = $img.attr('src') || '';

    const matched = imageData.find((item) => src.includes(item.origin));
    if (matched) {
      const newSrc = checkMatch(deviceType, matched);
      $img.attr('src', newSrc);
      $img.attr('data-src', newSrc);
    }
  });

  return $.html();
}
export function checkAndNormalizeUrls(data) {
  return data.map((url) => {
    if (/^https?:\/\//.test(url)) {
      return url; // đã đầy đủ http(s), không thay đổi
    }
    return `${BASE_FILE_URL}/${url}`;
  });
}
export function checkMatch(type, data) {
  if (type === 'mobile') {
    return `${BASE_FILE_URL}/${data?.small || data?.imgaeUrls}`;
  }
  if (type === 'tablet') {
    return `${BASE_FILE_URL}/${data?.medium || data?.imgaeUrls}`;
  }
  if (type === 'laptop' || type === 'desktop') {
    return `${BASE_FILE_URL}/${data?.large || data?.imgaeUrls}`;
  }
  return `${BASE_FILE_URL}/${data?.origin || data?.imgaeUrls}`;
}

export function checkType(type, data = {}, level = 0, originField = 'imgaeUrls', sharpField = 'imgaeUrlSharps') {
  // Định nghĩa các cấp url
  const levels = ['thumbnail', 'small', 'medium', 'large', 'origin'];
  const originUrl = data[originField];

  if (!originUrl) return '/img-default.png';

  // Xác định cấp hiện tại dựa vào type
  let currentLevel;
  if (type === 'mobile') currentLevel = 'small';
  else if (type === 'tablet') currentLevel = 'medium';
  else if (type === 'laptop') currentLevel = 'large';
  else currentLevel = 'origin';

  // Tìm vị trí cấp hiện tại
  let idx = levels.indexOf(currentLevel);

  // Điều chỉnh idx theo level truyền vào, đảm bảo nằm trong khoảng [0, levels.length - 1]
  idx = Math.max(0, Math.min(levels.length - 1, idx + level));

  // Lấy url theo cấp đã xác định, ưu tiên từ cấp đã điều chỉnh xuống origin
  let url = null;
  for (let i = idx; i < levels.length; i++) {
    url = data?.[sharpField]?.[levels[i]];
    if (url) break;
  }
  // Nếu không có thì lấy imgaeUrls
  if (!url) url = originUrl;

  return `${BASE_FILE_URL}/${url}`;
}
export const getDeviceType = () => {
  if (typeof window === 'undefined') return 'desktop';
  const width = window.innerWidth;
  if (width < 480) return 'mobile'; // Mobile: ≤ 480px
  if (width < 768) return 'tablet'; // Tablet: 481px – 768px
  if (width < 1024) return 'laptop'; // Laptop: 769px – 1024px
  return 'desktop';
};

export function slugify(title = '') {
  const slug = (title ?? '')
    .toLowerCase()
    .replace(/đ/g, 'd') // xử lý riêng chữ "đ"
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // loại bỏ dấu
    .replace(/[^a-z0-9\s-]/g, '') // loại bỏ ký tự đặc biệt
    .trim()
    .replace(/\s+/g, '-') // thay khoảng trắng bằng dấu -
    .replace(/-+/g, '-'); // gộp nhiều dấu - liên tiếp

  return slug.replace(/-+$/, '');
}

export async function getPageRendered({ websiteCode, path = '/', locale = '', sParams = {}, ...rest }) {
  const dataPageConfig = await fetchPageConfig(websiteCode, {
    path,
  });

  if (!dataPageConfig) return null;
  const modules = dataPageConfig?.modules || [];

  const components = {};

  // Tạo mảng các promises cho tất cả các API calls
  const modulePromises = modules.map(async (module) => {
    if (pageConfig[module] && !components[module]) {
      const fetchDataFuncs = Object.keys(pageConfig[module].fetchData || {});

      // Gọi tất cả fetchData functions song song bằng Promise.all
      const dataResults = await Promise.all(
        fetchDataFuncs.map(async (fetchDataFunc) => {
          const data = await pageConfig[module].fetchData[fetchDataFunc](
            locale,
            websiteCode,
            Object.assign({
              titleContent: sParams.search,
              menuSlug: rest?.slugDetail ?? rest?.slug,
              coQuanBanHanhIds: sParams.angency ? [sParams.angency] : [],
              loaiVanBanIds: sParams.textType ? [sParams.textType] : [],
              page: sParams.page,
              content: sParams.search,
            }),
            rest,
          );
          return { fetchDataFunc, data };
        }),
      );

      // Tạo props object từ results
      const props = {};
      dataResults.forEach(({ fetchDataFunc, data }) => {
        if (data._data) {
          Object.keys(data._data).forEach((key) => {
            props[key] = data._data[key];
          });
        } else {
          props[fetchDataFunc] = data;
        }
      });

      const Component = pageConfig[module].component;
      const componentElement = <Component key={module} {...props} {...rest} locale={locale} websiteCode={websiteCode} />;
      return { module, componentElement };
    }
    return null;
  });
  // Chờ tất cả modules được xử lý song song
  const moduleResults = await Promise.all(modulePromises);

  // Gán components vào object
  moduleResults.forEach((result) => {
    if (result) {
      components[result.module] = result.componentElement;
    }
  });

  const rendered = parse(dataPageConfig?.pageConfig?.html ?? DEFAULT_HOME_PAGE, {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode.name === 'div') {
        const dataModuleId = domNode.attribs['data-module-id'];
        if (domNode.attribs && pageConfig[dataModuleId]) {
          return components[dataModuleId] || null;
        }
      }
    },
  });
  return rendered;
}

export function detectDeviceFromUserAgent(uaRaw) {
  const ua = uaRaw || '';

  const isTablet = /iPad|Tablet|PlayBook|Nexus 7|Nexus 9|Nexus 10|SM-T\d+/i.test(ua);
  const isMobile = /Android.*Mobile|iPhone|iPod|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  if (isMobile) return 'mobile';
  if (isTablet) return 'tablet';

  // Còn lại coi là desktop / PC
  return 'desktop';
}

export function formatDateVN(dateString, dateFormat = 'dd/MM/yyyy') {
  try {
    return format(parseISO(dateString), dateFormat, { locale: vi });
  } catch {
    return '';
  }
}
